import { render, staticRenderFns } from "./MendingMilestoneButton.vue?vue&type=template&id=2dc5a23e&scoped=true&"
import script from "./MendingMilestoneButton.vue?vue&type=script&lang=js&"
export * from "./MendingMilestoneButton.vue?vue&type=script&lang=js&"
import style0 from "./MendingMilestoneButton.vue?vue&type=style&index=0&id=2dc5a23e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc5a23e",
  null
  
)

export default component.exports